import { InsightsNavbar } from "@/components/InsightsNavbar";
import { AnimatedSection } from "@/components/AnimatedSection";
import { ScrollProgressIndicator } from "@/components/ScrollProgressIndicator";
import { Footer } from "@/components/Footer";
import { InsightsLeadModal } from "@/components/InsightsLeadModal";
import { InsightsBreadcrumb } from "@/components/InsightsBreadcrumb";
import { PhishingHeroSection } from "@/components/insights/phishing/PhishingHeroSection";
import { PhishingTakeaway } from "@/components/insights/phishing/PhishingTakeaway";
import { PhishingFounderQuote } from "@/components/insights/phishing/PhishingFounderQuote";
import { PhishingKeyFindings } from "@/components/insights/phishing/PhishingKeyFindings";
import { PhishingRedFlags } from "@/components/insights/phishing/PhishingRedFlags";
import { PhishingPrevention } from "@/components/insights/phishing/PhishingPrevention";
import { InsightSEO } from "@/hooks/useInsightSEO";
import { RelatedTools } from "@/components/RelatedTools";
import { InsightEngagementTracker } from "@/components/InsightEngagementTracker";
import { InsightFAQSection } from "@/components/InsightFAQSection";
import { InsightBenchmarks } from "@/components/InsightBenchmarks";
import { TableOfContents } from "@/components/TableOfContents";

const PhishingAttackDetection = () => {
  return (
    <>
      <InsightSEO 
        slug="phishing-attack-detection" 
        additionalKeywords={["phishing email", "email scam", "social engineering", "credential theft", "cyber attack"]}
      />
      <InsightEngagementTracker slug="phishing-attack-detection" title="Phishing Attack Detection" />
      <InsightsNavbar showBack />
      <ScrollProgressIndicator />
      <TableOfContents />
      <InsightsLeadModal />
      <main className="page-container pb-16 sm:pb-20">
        <InsightsBreadcrumb 
          category="Cybersecurity" 
          currentPage="Phishing Attack Detection" 
        />
        <PhishingHeroSection />
        
        <AnimatedSection delay={100} className="mt-10 sm:mt-12">
          <PhishingTakeaway />
        </AnimatedSection>

        <AnimatedSection delay={50} className="mt-8 sm:mt-10">
          <PhishingFounderQuote />
        </AnimatedSection>

        <div className="section-divider" />

        <AnimatedSection delay={0}>
          <PhishingKeyFindings />
        </AnimatedSection>
        
        <AnimatedSection delay={0}>
          <PhishingRedFlags />
        </AnimatedSection>
        
        <AnimatedSection delay={0}>
          <PhishingPrevention />
        </AnimatedSection>
        
        {/* Benchmark Tables */}
        <AnimatedSection delay={0}>
          <InsightBenchmarks insightSlug="phishing-attack-detection" />
        </AnimatedSection>
        
        <AnimatedSection delay={0}>
          <InsightFAQSection insightSlug="phishing-attack-detection" />
        </AnimatedSection>
        
        <AnimatedSection delay={0}>
          <RelatedTools insightSlug="phishing-attack-detection" />
        </AnimatedSection>
      </main>
      <Footer />
    </>
  );
};

export default PhishingAttackDetection;
